import React from 'react';

const TaskContent = () => {
    return (
        <div>
            {/* Header with Add Task Button */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <button className="btn btn-primary btn-sm">+ New Task</button>
            </div>

            {/* Task List Table */}
            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Status</th>
                                    <th>Assignee</th>
                                    <th>Start Date</th>
                                    <th>Due Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Design Homepage</td>
                                    <td><span className="badge bg-success">Completed</span></td>
                                    <td>John Doe</td>
                                    <td>2024-02-28</td>
                                    <td>2024-02-28</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskContent;
